"use client";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as n from "@radix-ui/react-accordion";
import { cn as r } from "../../../utils/utils.mjs";
import { Icon as c } from "../Icon/Icon.mjs";
const f = ({ ...t }) => /* @__PURE__ */ o(n.Root, { "data-slot": "accordion", ...t });
function u({ className: t, ...e }) {
  return /* @__PURE__ */ o(
    n.Item,
    {
      "data-slot": "accordion-item",
      className: r("border-b last:border-b-0", t),
      ...e
    }
  );
}
function p({ className: t, iconClassName: e, children: i, ...a }) {
  return /* @__PURE__ */ o(n.Header, { children: /* @__PURE__ */ s(
    n.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: r(
        "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 flex flex-1 items-start justify-between gap-4 text-left hover:cursor-pointer transition-all outline-none disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        t
      ),
      ...a,
      children: [
        i,
        /* @__PURE__ */ o(
          c,
          {
            name: "chevronDown",
            className: r(
              "pointer-events-none size-3 translate-y-0.5 transition-transform duration-200",
              e
            )
          }
        )
      ]
    }
  ) });
}
function b({ className: t, children: e, ...i }) {
  return /* @__PURE__ */ o(
    n.Content,
    {
      "data-slot": "accordion-content",
      className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      ...i,
      children: /* @__PURE__ */ o("div", { className: r("", t), children: e })
    }
  );
}
export {
  b as AccordionContent,
  u as AccordionItem,
  f as AccordionRoot,
  p as AccordionTrigger
};
